/**
 * Doorware sidebar: filter + nav accordion toggles (collection + index).
 * Collection filters use a GET form (storefront filtering); this script does not intercept it.
 */
(function () {
  function toggleButton(btn) {
    var id = btn.getAttribute('aria-controls');
    if (!id) return;
    var panel = document.getElementById(id);
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open);
    panel.hidden = !open;
    var expand = btn.getAttribute('data-label-expand');
    var collapse = btn.getAttribute('data-label-collapse');
    if (expand && collapse) {
      btn.setAttribute('aria-label', open ? collapse : expand);
    }
  }

  document.addEventListener('click', function (e) {
    var collapseAll = e.target.closest('.dw-filters-collapse-all');
    if (collapseAll) {
      e.preventDefault();
      document.querySelectorAll('.dw-filter-accordion .dw-filter-acc-trigger').forEach(function (trig) {
        trig.setAttribute('aria-expanded', 'false');
        var pid = trig.getAttribute('aria-controls');
        if (pid) {
          var p = document.getElementById(pid);
          if (p) p.hidden = true;
        }
      });
      return;
    }
    var     btn = e.target.closest('.dw-filter-acc-trigger');
    if (btn) {
      e.preventDefault();
      toggleButton(btn);
      return;
    }
    btn = e.target.closest('.dw-home-sidebar-trigger');
    if (btn) {
      e.preventDefault();
      toggleButton(btn);
      return;
    }
    btn = e.target.closest('.dw-home-sidebar-trigger');
    if (btn) {
      e.preventDefault();
      toggleButton(btn);
      return;
    }
    btn = e.target.closest('.dw-nav-row--toggle');
    if (!btn) btn = e.target.closest('.dw-nav-row');
    if (btn && btn.classList.contains('dw-nav-row--link')) return;
    if (btn && btn.tagName === 'BUTTON') {
      e.preventDefault();
      toggleButton(btn);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest('.dw-filter-acc-trigger, .dw-home-sidebar-trigger, .dw-nav-row--toggle, .dw-nav-row');
    if (!btn || btn.classList.contains('dw-nav-row--link')) return;
    if (btn.tagName !== 'BUTTON') return;
    e.preventDefault();
    toggleButton(btn);
  });
})();
